/* =========================================================================
   HIRA MODA - Merkzettel / Wishlist (shopweit, ohne App)
   - Herz oben rechts auf jeder Produktkarte (Kollektion, Suche) + Produktseite
   - Herz-Symbol mit Zaehler im Header (neben Suche/Warenkorb)
   - Eigene Merkzettel-Seite (/pages/merkzettel)
   - Dauerhafte Speicherung in localStorage (Gaeste), geraeteuebergreifend per Tab-Sync
   - Dreisprachig de/en/ar inkl. RTL fuer Arabisch
   - Elegante SCHWARZE Herzen (leer = umrandet, gespeichert = gefuellt)
   Rein additiv: fuegt per JS Bedienelemente ein, aendert keine bestehende Logik.
   ========================================================================= */
(function () {
  if (window.__hmWishlist) return;
  window.__hmWishlist = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var LANG = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
  var IS_RTL = (LANG === 'ar');
  var KEY = 'hm_wishlist';

  var T = {
    de: {
      title: 'Merkzettel', add: 'Merken', added: 'Gemerkt', remove: 'Entfernen',
      toastAdd: 'Zum Merkzettel hinzugef\u00fcgt', toastRemove: 'Vom Merkzettel entfernt',
      empty: 'Dein Merkzettel ist noch leer.', emptyHint: 'Tippe auf das Herz an einem Produkt, um es hier zu speichern.',
      view: 'Zum Produkt', count: 'Artikel', shopnow: 'Jetzt shoppen'
    },
    en: {
      title: 'Wishlist', add: 'Save', added: 'Saved', remove: 'Remove',
      toastAdd: 'Added to your wishlist', toastRemove: 'Removed from wishlist',
      empty: 'Your wishlist is still empty.', emptyHint: 'Tap the heart on a product to save it here.',
      view: 'View product', count: 'items', shopnow: 'Start shopping'
    },
    ar: {
      title: '\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0641\u0636\u0644\u0629', add: '\u062d\u0641\u0638', added: '\u0645\u062d\u0641\u0648\u0638', remove: '\u0625\u0632\u0627\u0644\u0629',
      toastAdd: '\u062a\u0645\u062a \u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0625\u0644\u0649 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0641\u0636\u0644\u0629', toastRemove: '\u062a\u0645\u062a \u0627\u0644\u0625\u0632\u0627\u0644\u0629 \u0645\u0646 \u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0641\u0636\u0644\u0629',
      empty: '\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0641\u0636\u0644\u0629 \u0641\u0627\u0631\u063a\u0629.', emptyHint: '\u0627\u0636\u063a\u0637 \u0639\u0644\u0649 \u0627\u0644\u0642\u0644\u0628 \u0641\u064a \u0627\u0644\u0645\u0646\u062a\u062c \u0644\u062d\u0641\u0638\u0647 \u0647\u0646\u0627.',
      view: '\u0639\u0631\u0636 \u0627\u0644\u0645\u0646\u062a\u062c', count: '\u0645\u0646\u062a\u062c\u0627\u062a', shopnow: '\u0627\u0628\u062f\u0623 \u0627\u0644\u062a\u0633\u0648\u0642'
    }
  };
  var L = T[LANG] || T.de;

  var HEART_OUTLINE =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M12 20.5l-1.45-1.32C5.4 14.5 2 11.4 2 7.6 2 5 4 3 6.6 3c1.5 0 2.9.7 3.8 1.8L12 6.3l1.6-1.5C14.5 3.7 15.9 3 17.4 3 20 3 22 5 22 7.6c0 3.8-3.4 6.9-8.55 11.58L12 20.5z" ' +
    'stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  var HEART_FILLED =
    '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M12 20.5l-1.45-1.32C5.4 14.5 2 11.4 2 7.6 2 5 4 3 6.6 3c1.5 0 2.9.7 3.8 1.8L12 6.3l1.6-1.5C14.5 3.7 15.9 3 17.4 3 20 3 22 5 22 7.6c0 3.8-3.4 6.9-8.55 11.58L12 20.5z" ' +
    'fill="currentColor"/></svg>';

  /* ---------- Speicher ---------- */
  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    broadcast();
  }
  function broadcast() {
    try { window.dispatchEvent(new CustomEvent('hm-wishlist-change')); } catch (e) {}
  }
  function has(handle) {
    if (!handle) return false;
    return read().some(function (x) { return x.handle === handle; });
  }
  function add(entry) {
    if (!entry || !entry.handle) return;
    var list = read();
    if (list.some(function (x) { return x.handle === entry.handle; })) return;
    list.push(entry);
    write(list);
  }
  function remove(handle) {
    write(read().filter(function (x) { return x.handle !== handle; }));
  }
  function toggle(entry) {
    if (has(entry.handle)) { remove(entry.handle); return false; }
    add(entry); return true;
  }
  function count() { return read().length; }

  window.HMWishlist = {
    get: read, has: has, add: add, remove: remove, toggle: toggle, count: count
  };

  /* ---------- Helfer ---------- */
  function handleFromUrl(url) {
    if (!url) return '';
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  /* ---------- Toast ---------- */
  function toast(msg) {
    try {
      var t = document.createElement('div');
      t.className = 'hm-wl-toast' + (IS_RTL ? ' hm-wl-rtl' : '');
      t.innerHTML = '<span class="hm-wl-toast__i">' + HEART_FILLED + '</span><span>' + escapeHtml(msg) + '</span>';
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-in'); });
      setTimeout(function () {
        t.classList.remove('is-in');
        setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 320);
      }, 1600);
    } catch (e) {}
  }

  /* ---------- Herz-Button erzeugen ---------- */
  function makeHeart(entry, cls) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hm-wl-heart' + (cls ? ' ' + cls : '');
    btn.setAttribute('data-hm-wl-handle', entry.handle);
    btn.setAttribute('aria-label', L.add);
    var saved = has(entry.handle);
    btn.innerHTML = saved ? HEART_FILLED : HEART_OUTLINE;
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var nowSaved = toggle(entry);
      toast(nowSaved ? L.toastAdd : L.toastRemove);
      // kleine Puls-Animation
      btn.classList.remove('is-pulse'); void btn.offsetWidth; btn.classList.add('is-pulse');
    });
    return btn;
  }

  /* ---------- Produktkarten (Kollektion / Suche) ---------- */
  function enhanceCards(scope) {
    var cards = (scope || document).querySelectorAll('.card-wrapper.product-card-wrapper:not(.dummy-product):not([data-hm-wl])');
    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('data-hm-wl', '1');
      var link = card.querySelector('a[href*="/products/"]');
      var inner = card.querySelector('.card__inner');
      if (!link || !inner) return;
      var handle = handleFromUrl(link.getAttribute('href'));
      if (!handle) return;

      var titleEl = card.querySelector('.card__heading a, .card__heading');
      var priceEl = card.querySelector('.price__sale .price-item--sale, .price .price-item--regular, .price .price-item');
      var imgEl = card.querySelector('.card__media img, img');
      var entry = {
        handle: handle,
        title: clean(titleEl ? titleEl.textContent : ''),
        url: link.getAttribute('href'),
        img: imgEl ? (imgEl.currentSrc || imgEl.src || '') : '',
        price: clean(priceEl ? priceEl.textContent : '')
      };
      if (inner.querySelector('.hm-wl-heart')) return;
      if (getComputedStyle(inner).position === 'static') inner.style.position = 'relative';
      inner.appendChild(makeHeart(entry, 'hm-wl-heart--card'));
    });
  }

  /* ---------- Produktdetailseite ---------- */
  function enhancePdp() {
    if (!/\/products\//.test(window.location.pathname)) return;
    var gallery = document.querySelector('.product__media-wrapper .product__media-list, .product__media-wrapper, media-gallery');
    if (!gallery) return;
    var host = gallery.querySelector('.product__media-item') || gallery;
    if (!host || host.querySelector('.hm-wl-heart')) return;

    var handle = handleFromUrl(window.location.pathname);
    if (!handle) return;
    var titleEl = document.querySelector('.product__title, .product__info-container .product__title h1, h1');
    var priceEl = document.querySelector('.product__info-container .price__sale .price-item--sale, .product__info-container .price .price-item--regular, .product__info-container .price .price-item');
    var imgEl = host.querySelector('img') || document.querySelector('.product__media img');
    var entry = {
      handle: handle,
      title: clean(titleEl ? titleEl.textContent : (document.title || '')),
      url: ROOT + 'products/' + handle,
      img: imgEl ? (imgEl.currentSrc || imgEl.src || '') : '',
      price: clean(priceEl ? priceEl.textContent : '')
    };
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(makeHeart(entry, 'hm-wl-heart--pdp'));
  }

  /* ---------- Header-Symbol + Zaehler ---------- */
  function ensureHeaderIcon() {
    var icons = document.querySelector('.header__icons');
    if (!icons) return;
    if (icons.querySelector('.hm-wl-head')) { updateHeaderBadge(); return; }

    var a = document.createElement('a');
    a.className = 'hm-wl-head header__icon header__icon--wishlist link focus-inset';
    a.href = ROOT + 'pages/merkzettel';
    a.setAttribute('aria-label', L.title);
    a.innerHTML = HEART_OUTLINE + '<span class="hm-wl-head__badge" aria-hidden="true">0</span>' +
      '<span class="visually-hidden">' + escapeHtml(L.title) + '</span>';
    if (IS_RTL) a.setAttribute('dir', 'rtl');

    var cart = icons.querySelector('#cart-icon-bubble');
    if (cart && cart.parentNode === icons) icons.insertBefore(a, cart);
    else icons.appendChild(a);
    updateHeaderBadge();
  }
  function updateHeaderBadge(pop) {
    var head = document.querySelector('.hm-wl-head');
    if (!head) return;
    var n = count();
    var badge = head.querySelector('.hm-wl-head__badge');
    if (badge) { badge.textContent = n; badge.style.display = n > 0 ? '' : 'none'; }
    head.classList.toggle('has-items', n > 0);
    if (pop) {
      head.classList.remove('is-pop'); void head.offsetWidth; head.classList.add('is-pop');
      setTimeout(function () { head.classList.remove('is-pop'); }, 500);
    }
  }

  /* ---------- Alle sichtbaren Herzen synchron halten ---------- */
  function syncHearts() {
    var saved = {};
    read().forEach(function (x) { saved[x.handle] = true; });
    Array.prototype.forEach.call(document.querySelectorAll('.hm-wl-heart'), function (btn) {
      var h = btn.getAttribute('data-hm-wl-handle');
      var on = !!saved[h];
      if (btn.classList.contains('is-saved') !== on) {
        btn.classList.toggle('is-saved', on);
        btn.innerHTML = on ? HEART_FILLED : HEART_OUTLINE;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    });
  }

  /* ---------- Merkzettel-Seite ---------- */
  function renderWishlistPage() {
    var root = document.getElementById('hm-wishlist-root');
    if (!root) return;
    if (IS_RTL) root.setAttribute('dir', 'rtl');
    var list = read();

    var head = '<div class="hm-wlp__head"><h1 class="hm-wlp__title">' + escapeHtml(L.title) +
      '</h1><span class="hm-wlp__count">' + list.length + ' ' + escapeHtml(L.count) + '</span></div>';

    if (!list.length) {
      root.innerHTML = head +
        '<div class="hm-wlp__empty">' +
        '<div class="hm-wlp__empty-i">' + HEART_OUTLINE + '</div>' +
        '<p class="hm-wlp__empty-t">' + escapeHtml(L.empty) + '</p>' +
        '<p class="hm-wlp__empty-h">' + escapeHtml(L.emptyHint) + '</p>' +
        '<a class="hm-wlp__shop button" href="' + ROOT + '">' + escapeHtml(L.shopnow) + '</a>' +
        '</div>';
      return;
    }

    var cards = list.map(function (it) {
      return '<div class="hm-wlp__card" data-handle="' + escapeHtml(it.handle) + '">' +
        '<a class="hm-wlp__media" href="' + escapeHtml(it.url || (ROOT + 'products/' + it.handle)) + '">' +
        (it.img ? '<img src="' + escapeHtml(it.img) + '" alt="" loading="lazy">' : '<span class="hm-wlp__noimg"></span>') +
        '</a>' +
        '<button type="button" class="hm-wlp__rm" data-rm="' + escapeHtml(it.handle) + '" aria-label="' + escapeHtml(L.remove) + '">' + HEART_FILLED + '</button>' +
        '<a class="hm-wlp__name" href="' + escapeHtml(it.url || (ROOT + 'products/' + it.handle)) + '">' + escapeHtml(it.title) + '</a>' +
        (it.price ? '<div class="hm-wlp__price">' + escapeHtml(it.price) + '</div>' : '') +
        '<a class="hm-wlp__view" href="' + escapeHtml(it.url || (ROOT + 'products/' + it.handle)) + '">' + escapeHtml(L.view) + '</a>' +
        '</div>';
    }).join('');

    root.innerHTML = head + '<div class="hm-wlp__grid">' + cards + '</div>';
  }

  // Klicks auf der Merkzettel-Seite (Entfernen)
  document.addEventListener('click', function (e) {
    var rm = e.target.closest ? e.target.closest('[data-rm]') : null;
    if (!rm) return;
    e.preventDefault();
    var h = rm.getAttribute('data-rm');
    remove(h);
    var card = rm.closest('.hm-wlp__card');
    if (card) {
      card.style.transition = 'opacity .2s ease';
      card.style.opacity = '0';
      setTimeout(renderWishlistPage, 200);
    }
    toast(L.toastRemove);
  });

  /* ---------- Reaktion auf Aenderungen ---------- */
  function onChange() {
    syncHearts();
    updateHeaderBadge(true);
    renderWishlistPage();
  }
  window.addEventListener('hm-wishlist-change', onChange);
  window.addEventListener('storage', function (e) { if (e.key === KEY) onChange(); });

  /* ---------- Start + Beobachtung ---------- */
  function run(scope) {
    ensureHeaderIcon();
    enhanceCards(scope);
    /* enhancePdp();  -- Produktseiten-Herz deaktiviert (Bildbereich bleibt unberuehrt) */
    renderWishlistPage();
    syncHearts();
    updateHeaderBadge();
  }

  function boot() {
    run(document);
    if (window.MutationObserver) {
      var pending = false;
      var obs = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; run(document); }, 150);
      });
      var target = document.getElementById('MainContent') || document.body;
      obs.observe(target, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { setTimeout(function () { run(document); }, 150); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
